import Router from '@medical/routes/router'
import moment from 'moment'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { InfoCircleFilled } from '@ant-design/icons'
const DoctorCartConfirmation = ({
  values,
  isSubmitting,
  handleSubmit,
  handleNoClick,
  setFieldValue,
  confirmationMessage,
  children,
  removeItemFromCart,
  visibleKey = 'confirm',
}) => {
  const { i18n } = useTranslation()

  const redirect = () => {
    const now = moment()
    const fileUrl = Router.get(Router.doctorAvailableShifts, {
      year: now.year(),
      month: now.month() + 1,
    })
    window.location.href = fileUrl
  }
  const noClick = () => {
    setFieldValue(visibleKey, false)
  }

  return (
    <Dialog
      header={
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          <InfoCircleFilled style={{ fontSize: '18px', marginRight: '5px' }} />
          {i18n.t('doctor.cart.titleConfirm')}
        </span>
      }
      visible={values[visibleKey]}
      className="p-dialog"
      footer={
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '0.5em',
          }}
        >
          <span
            style={{
              fontWeight: 'bold',
              flex: '1 1 auto',
              minWidth: '200px',
              textAlign: 'left',
            }}
          >
            {i18n.t('doctor.cart.submitConfirmation')}
          </span>
          <div style={{ display: 'flex', gap: '0.5em', flexWrap: 'wrap' }}>
            <Button
              type="submit"
              label="同意する"
              icon={`pi pi-${isSubmitting ? 'spinner pi-spin' : 'check'}`}
              disabled={isSubmitting}
              onClick={handleSubmit}
              style={{ flex: '0 0 auto', minWidth: '120px' }}
            />
            <Button
              label="同意しない"
              icon="pi pi-times"
              onClick={() => {
                values.items.forEach(item => {
                  setFieldValue('items', [])
                  removeItemFromCart(item.id)
                })
                noClick && noClick()
                redirect && redirect()
              }}
              className="p-button-secondary"
              disabled={isSubmitting}
              style={{ flex: '0 0 auto', minWidth: '120px' }}
            />
          </div>
        </div>
      }
      closable={!isSubmitting}
      onHide={handleNoClick || noClick}
    >
      {children}
      <div style={{ whiteSpace: 'pre-line' }}>
        <span>{i18n.t('doctor.cart.applicationNoticeTitle')}</span>
        <span style={{ color: 'red' }}>{i18n.t('doctor.cart.noticeWarning')}</span>
        <span>{i18n.t('doctor.cart.noticeWarning2')}</span>
        <span>{i18n.t('doctor.cart.noticeNotification')}</span>
        <span>{i18n.t('doctor.cart.noticeConfirmation')}</span>
        {'\n'}
        <span>{i18n.t('doctor.cart.cancellationPolicy')}</span>
        <span>{i18n.t('doctor.cart.cancellationPolicy2')}</span>
      </div>
    </Dialog>
  )
}

export default DoctorCartConfirmation
